import {
  createContext
} from "react";

const SpecialitiesContext = createContext();

export default SpecialitiesContext;